module.exports = __webpack_public_path__ + "img/logo_3.9e3b5200.png";